<template>
    <div class="ts-finder__infowindow" :class="{ 'ts-finder__infowindow--with-promobanner' : station.promobannerurl }">
        <img :src="station.promobannerurl" v-if="station.promobannerurl" class="ts-finder__infowindow-promobanner" />
        <div class="ts-finder__infowindow-station-details-container">
            <div class="ts-finder__infowindow-directions">
                <a class="ts-finder__infowindow-directions-link" :href="directionsUrl" target="_blank" v-if="directionsUrl" :title="strings['TsFinder.Map.Routeplanner']"><i class="fas fa-directions"></i></a><br />
                {{station.distance | formatDistance}}
            </div>
            <img :src="station.brandurl" class="ts-finder__infowindow-station-brand" />
            <div class="ts-finder__infowindow-station-details">
                <div class="ts-finder__infowindow-station-name">{{station.name}}</div>
                <div class="ts-finder__infowindow-station-address" v-html="station.address"></div>
                <ul class="ts-finder__infowindow-services-list" v-if="!isTempClosed">
                    <li class="ts-finder__icon ts-finder__icons-tankstelle" v-if="this.station.tankstelle" :title="strings['TsFinder.Filter.Tankstelle']"></li>
                    <li class="ts-finder__icon ts-finder__icons-fastcharging" v-if="this.station.fastcharging" :title="strings['TsFinder.Filter.FastCharging']"></li>
                    <li class="ts-finder__icon ts-finder__icons-wasserstoff" v-if="this.station.wasserstoff" :title="strings['TsFinder.Filter.Wasserstoff']"></li>
                    <li class="ts-finder__icon ts-finder__icons-shop" v-if="this.station.shop" :title="strings['TsFinder.Filter.ShopMigrol']"></li>
                    <li class="ts-finder__icon ts-finder__icons-migrolino" v-if="this.station.migrolino" :title="strings['TsFinder.Filter.ShopMigrolino']"></li>
                    <li class="ts-finder__icon ts-finder__icons-mio" v-if="this.station.mio" :title="strings['TsFinder.Filter.ShopMio']"></li>
                    <li class="ts-finder__icon ts-finder__icons-carwash" v-if="this.station.carwash" :title="strings['TsFinder.Filter.CarWash']"></li>
                    <li class="ts-finder__icon ts-finder__icons-autoservice" v-if="this.station.autoservice" :title="strings['TsFinder.Filter.AutoService']"></li>
                    <li class="ts-finder__icon ts-finder__icons-migrolcard" :title="strings['TsFinder.Filter.IsMigrolStandort']"></li>
                    <li class="ts-finder__icon ts-finder__icons-hasWC" v-if="this.station.wc" title="WC"></li>
                </ul>
                <div class="ts-finder__infowindow-temp-closed" v-if="isTempClosed">{{strings['TsFinder.Map.TempClosed']}}</div>
            </div>
            <div class="ts-finder__infowindow-details-link" v-if="!isTempClosed">
                <router-link :to="station.detailsurl">{{strings['TsFinder.Map.DetailsLink']}} <i class="fas fa-angle-right"></i></router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        props: {
            station: Object,
            userLocation: Object
        },
        computed: {
            ...mapState([
                'strings'
            ]),
            directionsIcon() {
                return window.TS_CONFIG.directions;
            },
            directionsUrl() {
                if (this.station.latitude && this.station.longitude) {
                    var url = 'https://www.google.com/maps/dir/?api=1&travelmode=driving&destination=' + this.station.latitude + ',' + this.station.longitude;
                    if (this.userLocation != null) {
                        url += '&origin=' + this.userLocation.latitude + ',' + this.userLocation.longitude;
                    }
                    return url;
                } else {
                    return null;
                }
            },
            isTempClosed() {
                return this.station.tempclosed === true;
            },
            detailsUrl() {
                return '/' + this.station.detailsurl;
            }
        }
    };
</script>